/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HalJson } from '../../models/hal-json';
import { SkumapTemplateCreateResult } from '../../models/skumap-template-create-result';
import { SkumapTemplateRequest } from '../../models/skumap-template-request';

export interface SkumapTemplatesPost$Params {
  'Active-Tenant-Identifier': string;
      body: SkumapTemplateRequest
}

export function skumapTemplatesPost(http: HttpClient, rootUrl: string, params: SkumapTemplatesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
} & SkumapTemplateCreateResult>> {
  const rb = new RequestBuilder(rootUrl, skumapTemplatesPost.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: HalJson;
      } & SkumapTemplateCreateResult>;
    })
  );
}

skumapTemplatesPost.PATH = '/skumap/templates';
